import { SocialSubscriptionService } from './social-subscription.service';
const service = new SocialSubscriptionService();

const state = {};

const getters = {};

const mutations = {};

const actions = {
   async getSocialSubscriptions(
      context: any,
      payload: { commuter_traffic_type_id: number; commuter_traffic_distance: number; joint_committee_number: number },
   ) {
      return await service.getSocialSubscriptions(
         payload.commuter_traffic_distance,
         payload.commuter_traffic_type_id,
         payload.joint_committee_number,
      );
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
